export default __webpack_public_path__ + "static/media/bathroom.97a0f4b6.jpg";